import LocalPostsModal from './localPostsModal'

export default LocalPostsModal